module.exports = __webpack_public_path__ + "static/2-eb3cec1a20bcd98cbe276e9804a3b6f6.png";